import { useNavigate } from 'react-router-dom';
import { Icon, TextButton } from '../../components';
import ScorecardTemplatesTable from './ScorecardTemplatesTable';

const ScorecardsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col gap-4">
      <TextButton
        className="ml-auto"
        startIcon={Icon.PLUS}
        text="Create new"
        onClick={() => navigate('create', { replace: true })}
      />
      <ScorecardTemplatesTable />
    </div>
  );
};

export default ScorecardsPage;
